import DropdownContainer from "../../Componant/Ui Kit/Dropdown";

const Dropdown = () => {
  return (
    <div className="page-body">
        <DropdownContainer/>
    </div>
  )
};

export default Dropdown;
